import { createContentHook } from './createContentHook';
import type { CommonContent } from '../types/CommonContent';

export const useCommonContent = createContentHook<CommonContent>('/_common');
